import alt from '../alt'
import BookingActions from './BookingActions'

import { get, post, setToken } from '../core/HttpClient'
import { formDataToOrder, formDataToOrderEstimate } from '../utils/convert'

class FormActions {
  constructor () {
    this.generateActions(
      'selectAttribute',
      'selectAttributeValue',
      'selectCarType',
      'selectPriceType',
      'setBaggage',
      'setLoading',
      'setValidating',
      'setFixedPrice',
      'setEstimateLoading',
      'setShowInfoMessage',
      'setSendSMS',
      'dateChange',
      'accountChange',
      'displayErrorMessage',
      'timeChange',
      'receivedDestinations',
      'inputChange',
      'updateTime',
      'accountPasswordChange',
      'referenceChange',
      'showAccountDetails',
      'receivedPriceEstimate',
      'clearPriceEstimate',
      'killEstimateTimer',
      'receivedLocationInfo',
      'clearDeparture',
      'clearDestination',
      'bookingCommissionEnabled',
      'receivedUser'
    )
  }

  initLocationParams (params) {
    return (dispatch) => {
      setToken(params.token)
      dispatch(params)
      this.receivedUser(params)
    }
  }

  validateAccount (formData) {
    return (dispatch) => {
      dispatch()
      console.log(formData)
      this.setValidating(true)

      const order = formDataToOrder(formData)

      // NOTE: the validateAccount middleware is used both when validating an account and creating the booking.
      // This property is used to skip checking if the selected account requires a destination and only check password and reference.
      order.skipDestinationCheck = true

      post('/validate', order)
        .then(res => {
          if (res && res.error) {
            const message = res.message && res.message.length < 100 ? res.message : res.error
            this.displayErrorMessage({ message: message, code: res.status })
          }
          else {
            this.showAccountDetails(false)
          }
        })
        .catch(res => {
          console.error(res)
          if (res && res.error) {
            const message = res.message && res.message.length < 100 ? res.message : res.error
            this.displayErrorMessage({ message: message, code: res.status })
          }
        })
        .finally(() => {
          this.setValidating(false)
        })
    }
  }

  estimatePrice (formData) {
    console.log('estimatePrice')
    return (dispatch) => {
      dispatch()
      this.setEstimateLoading(true)
      const order = formDataToOrderEstimate(formData)
      post('/price/estimate', order)
        .then(res => {
          console.log(res)
          this.receivedPriceEstimate(res)
        })
        .catch(res => {
          console.error(res)
          if (res && res.error) {
            const message = res.message && res.message.length < 100 ? res.message : res.error
            this.displayErrorMessage({ message: message, code: res.status })
          }
        })
        .finally(() => {
          this.setEstimateLoading(false)
        })        
    }    
  }

  book (formData) {
    return (dispatch) => {
      dispatch()
      console.log(formData)
      this.setLoading({ loading: true })
      const order = formDataToOrder(formData)
      console.log('ORDER SENT:', order)

      post('/bookings', order)
        .then(res => {
          console.log(res)
          if (res && res.bookingId) {
            if (formData.email !== '') {
              this.sendConfirmation(res.bookingId, formData.email)
            }
            BookingActions.fetchBookings()
            this.setLoading({ loading: false, bookingSuccess: true })
          } else {
            this.setLoading({ loading: false })
          }
          if (res && res.error) {
            const message = res.message && res.message.length < 100 ? res.message : res.error
            this.displayErrorMessage({ message: message, code: res.status })
          }
        })
        .catch(res => {
          console.log(res)
          if (res && res.error) {
            const message = res.message && res.message.length < 100 ? res.message : res.error
            this.displayErrorMessage({ message: message, code: res.status })
          }
          this.setLoading({ loading: false, bookingSuccess: false })
        })
    }
  }

  sendConfirmation (orderId, email, cb) {
    return (dispatch) => {
      dispatch()
      post(`/bookings/${orderId}/email-confirmation`, { email })
        .then(res => {
          console.log(res)
          if (cb) cb(true)
        })
        .catch(res => {
          console.log(res)
          if (res && res.error) {
            const message = res.message && res.message.length < 100 ? res.message : res.error
            this.displayErrorMessage({ message: message, code: res.status })
            if (cb) cb(false)
          }      
        })
    }    
  }

  searchDestination (type, value, region, city) {
    return (dispatch) => {
      dispatch()
      value = value.replace(/[\s,]+/g, ' ')
      if (value && value.length > 0) {
        let url = `/locations/search?address_string=${encodeURIComponent(value)}`
        if (region !== undefined && region !== null) {
          url += `&region=${encodeURIComponent(region)}`
        }
        if (city !== undefined && city !== null) {
          url += `&city=${encodeURIComponent(city)}`
        }
        get(url)
          .then(res => {
            this.receivedDestinations({ type, destinations: res.result })
          })
          .catch(err => console.error(err))
      } else {
        this.receivedDestinations({ type, destinations: [] })
      }
    }
  }

  destinationSelected (type, value) {
    console.log('dest sel:', type, value)
    return (dispatch) => {
      dispatch({ type, destination: value })
    }
  }

  fetchLocationInfo (type, location) {
    return (dispatch) => {
      dispatch()

      get(`/locations/${location.id}`)
      .then(res => {
        this.receivedLocationInfo({ type, info: res })
      })
      .catch(err => console.error(err))
    }
  }

}

export default alt.createActions(FormActions)
